import { render, staticRenderFns } from "./VideoInline.vue?vue&type=template&id=c2330f9e&"
import script from "./VideoInline.vue?vue&type=script&lang=js&"
export * from "./VideoInline.vue?vue&type=script&lang=js&"
import style0 from "./VideoInline.vue?vue&type=style&index=0&id=c2330f9e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports